import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { LoginCredentialsDto } from './_dtos/login.dto';
import { UserDto } from './_dtos/user.dto';
import { RegisterDto } from './_dtos/register.dto';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService extends ApiBaseService {
  override scope = 'auth';

  login(credentials: LoginCredentialsDto) {
    return this.post<{ token: string, user: UserDto }>(credentials, 'login');
  }

  logout() {
    return this.post({}, 'logout');
  }

  getMe() {
    return this.get<{ user: UserDto }>('me');
  }

  register(data: RegisterDto) {
    return this.post<{ token: string, user: UserDto }>(data, 'register');
  }

  forgotPassword(email: string) {
    return this.post<{ message: string }>({ email }, 'forgot-password');
  }

  /**
   * Get OAuth redirect URL for a provider
   */
  getOAuthUrl(provider: 'google' | 'apple') {
    return this.get<{ url: string }>(`social/${provider}/redirect`);
  }

  /**
   * Authenticate with OAuth provider using token
   */
  socialLogin(provider: 'google' | 'apple', token: string) {
    return this.post<{ token: string, user: UserDto }>({ token }, `social/${provider}`);
  }

  /**
   * Link OAuth provider to existing account
   */
  linkProvider(provider: 'google' | 'apple', token: string) {
    return this.post<{ message: string, user: UserDto }>({ provider, token }, 'social/link');
  }
}
